module.exports = __webpack_public_path__ + "img/portrait-078.b8699d31.jpg";